import request from '../helpers/request';
import { product } from './apiMapping';


/**
 * Get current product options (Plans, Types etc)
 *
 * @returns {Promise}
 */
const getProductDataList = () => request(product.getProductDataList);

/**
 * Search for a discount using a coupon
 *
 * @param {string} coupon
 * @returns {Promise}
 */
const getCouponDiscount = (coupon) => request(product.getCouponDiscount, { coupon }, { method: 'post' });


export { getProductDataList, getCouponDiscount };